import type { ResidentAppPageCopy } from './types';

/**
 * Estate / golf-resort voice — used by `dev` and `ip4x-root` builds.
 * Generic community builds omit this and rely on `DEFAULT_PAGE_COPY`.
 */
export const ESTATE_PAGE_COPY: ResidentAppPageCopy = {
  facilities: {
    eyebrow: 'Hospitality',
    title: 'Facility bookings',
    subtitle: 'Book estate facilities.',
    searchPlaceholder: 'Search facilities…',
    detail: {
      availableTimes: 'Available times',
    },
  },
  documents: {
    subtitle: 'Rules, notices and forms.',
  },
  events: {
    eyebrow: 'Estate life',
    subtitle: 'Estate events.',
    emptyDescription: 'Estate events will appear here.',
  },
  gallery: {
    eyebrow: 'Estate gallery',
    subtitle: 'Estate photos.',
  },
  map: {
    subtitle: 'Estate locations and amenities.',
    locationsDescription: 'Published estate locations, ready to open in your maps app.',
  },
  faq: {
    subtitle: 'Answers to common questions.',
  },
  classifieds: {
    subtitle: 'Buy, sell and share locally.',
  },
  properties: {
    eyebrow: 'Estate',
    subtitle: 'Linked properties and claims.',
  },
  invoices: {
    subtitle: 'Balances, invoices and statements.',
  },
  support: {
    list: {
      subtitle: 'Track support requests.',
    },
  },
  welcomeTour: [
    {
      eyebrow: 'Welcome home',
      title: 'A warm welcome to {name}.',
      body: 'Your account is ready. Take a quick tour of what your residence app can do.',
    },
    {
      eyebrow: 'All in one place',
      title: 'Your estate, at your fingertips.',
      body: 'Visitor access, facility bookings, statements and estate news — a tap away.',
    },
    {
      eyebrow: 'Always looked after',
      title: 'Help, whenever you need it.',
      body: 'Panic SOS, security contacts and resident support are always within reach.',
    },
  ],
};
